import { jsx as _jsx } from "react/jsx-runtime";
import { throttle } from 'lodash';
import { useEffect, useRef } from 'react';
const THROTTLE_DELAY = 150;
export const InfiniteLoadObserver = ({ onIntersect, thresholdAbove = 0, }) => {
    const ref = useRef(null);
    useEffect(() => {
        if (ref.current && onIntersect) {
            const onScroll = throttle(() => {
                if (ref.current) {
                    const { height, top, width } = ref.current.getBoundingClientRect();
                    if (height && width && top - thresholdAbove <= window.innerHeight) {
                        onIntersect();
                    }
                }
            }, THROTTLE_DELAY);
            window.addEventListener('scroll', onScroll);
            onScroll();
            return () => {
                window.removeEventListener('scroll', onScroll);
            };
        }
        return undefined;
    }, [onIntersect, thresholdAbove]);
    return onIntersect ? (_jsx("div", { "data-testid": "infinite-load-observer", ref: ref, style: { height: '1px' } })) : null;
};
//# sourceMappingURL=index.js.map